// Linear's toolbar buttons (filter, display, new): a 28px circle with a
// hairline, the icon muted until the pointer is over it. Spread onto an
// IconButton: <IconButton {...TOOLBAR_ICON_BUTTON} icon={...} aria-label={...} />
export const TOOLBAR_ICON_BUTTON = {
  size: 'sm',
  variant: 'ghost',
  w: '28px',
  minW: '28px',
  h: '28px',
  p: 0,
  borderRadius: 'full',
  border: '1px solid',
  borderColor: 'redesign.border',
  color: 'redesign.text.muted',
  _hover: { color: 'redesign.heading', bg: 'redesign.bg.hover' },
  _active: { bg: 'redesign.bg.hover' },
};

export default TOOLBAR_ICON_BUTTON;
